// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, WeaverDefinedNode;

  Weaver = require('./Weaver');

  WeaverDefinedNode = class WeaverDefinedNode extends Weaver.Node {
    constructor(nodeId, graph, model) {
      super(nodeId, graph);
      this.model = model;
    }

    getDefinitions() {
      var def, defs;
      defs = (function() {
        var i, len, ref, results;
        ref = this.relation(this.model.getMemberKey()).all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          def = ref[i];
          results.push(def.id());
        }
        return results;
      }).call(this);
      defs = this.model.addSupers(defs);
      return defs;
    }

  };

  
  // Export
  module.exports = WeaverDefinedNode;

}).call(this);
